import { useEffect, useState } from 'react';

const scriptsLoadMap: Map<string, boolean> = new Map();

export const useScript = (url: string) => {
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        if (!url) {
            return;
        }

        if (scriptsLoadMap.get(url)) {
            setIsLoaded(true);
            return;
        }

        const script = document.createElement('script');

        script.src = url;
        script.async = true;
        script.onload = () => {
            scriptsLoadMap.set(url, true);
            setIsLoaded(true);
        };

        document.head.appendChild(script);
    }, [url]);

    return isLoaded;
};
